import React from 'react';

import { UiKit } from 'components';
import { useRequestReasonDelete } from '../context';

/**
 * @param {Object} props
 * @param {import('utils/types').ButtonVariant} props.variant
 * @param {string} props.className
 * @param {React.ReactNode} props.children
 */
export default function Trigger({ children = 'Delete' }) {
  const { isProcessing, onDelete } = useRequestReasonDelete();

  return (
    <UiKit.Button
      variant="ghost-destructive"
      onClick={onDelete}
      processing={isProcessing}
    >
      {children}
    </UiKit.Button>
  );
}
